import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import api from '../assets/api.png';
import css from '../assets/css.png';
import figma from '../assets/figma.png';
import git from '../assets/git.png';
import graphql from '../assets/graphql.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import mu5 from '../assets/mu5.png';
import node from '../assets/node.png';
import react from '../assets/react.png';
import redux from '../assets/redux.png';
import sass from '../assets/sass.png';
import typescript from '../assets/typescript.png';
import dev from '../assets/development.svg';
import heroPattern from '../assets/hero-pattern.svg';
import responsive from '../assets/responsive.svg';
import profil from '../assets/Profile-image.png';
import circle from '../assets/circle.svg';
import blob from '../assets/blob.svg';
import bgWhite from '../assets/bgWhite.png';
import logo from '../assets/logo.svg';
import hero from '../assets/hero.webp';

const image = {
  hero,
  logo,
  responsive,
  blob,
  bgWhite,
  email,
  mobile,
  api,
  css,
  figma,
  git,
  graphql,
  html,
  javascript,
  mu5,
  node,
  react,
  redux,
  sass,
  typescript,
  profil,
  circle,
  dev,
  heroPattern,
};

export default image;
